<template>
  <chatflow-page>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="contacts"
      class="shadow-xl cf-card"
      elevation="2"
    >
      <template v-slot:top>
        <v-toolbar flat color="white" class="px-2">
          <v-toolbar-title class="text-h6 font-weight-medium">Rehber</v-toolbar-title>
          <v-spacer />
          <v-text-field
            v-model="search"
            dense
            outlined
            prepend-inner-icon="mdi-magnify"
            label="Ara"
            hide-details
            class="cf-search mr-2"
            @keyup.enter="load"
          />
          <v-btn color="primary" depressed class="mr-2" @click="openNew">
            <v-icon left small>person_add</v-icon>
            Yeni
          </v-btn>
          <v-btn text small color="primary" @click="load">Yenile</v-btn>
        </v-toolbar>
        <v-divider />
      </template>
      <template v-slot:item.primaryEmail="{ item }">
        {{ item.primaryEmail || "—" }}
      </template>
      <template v-slot:item.primaryPhone="{ item }">
        {{ item.primaryPhone || "—" }}
      </template>
      <template v-slot:item.telegramChatId="{ item }">
        {{ item.telegramChatId || "—" }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn icon small @click="openEdit(item)">
          <v-icon small>edit</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="480" persistent>
      <v-card>
        <v-card-title class="subtitle-1">
          {{ editId ? "Kayıt düzenle" : "Yeni rehber kaydı" }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <v-text-field v-model="form.displayName" label="Görünen ad" outlined dense />
          <v-text-field v-model="form.email" label="E-posta" outlined dense />
          <v-text-field v-model="form.phone" label="Telefon" outlined dense />
          <v-text-field v-model="form.telegramChatId" label="Telegram chat id" outlined dense />
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-4 py-3">
          <v-spacer />
          <v-btn text @click="dialog = false">İptal</v-btn>
          <v-btn color="primary" depressed :loading="saving" @click="save">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snack" :color="snackColor">{{ snackText }}</v-snackbar>
  </chatflow-page>
</template>

<script>
import ChatflowApi from "../api";
import ChatflowAuthMixin from "../mixins/auth";
import ChatflowPage from "../components/ChatflowPage.vue";

export default {
  components: { ChatflowPage },
  mixins: [ChatflowAuthMixin("Chatflow Contacts")],
  data: () => ({
    loading: false,
    saving: false,
    search: "",
    contacts: [],
    dialog: false,
    editId: null,
    form: { displayName: "", email: "", phone: "", telegramChatId: "" },
    headers: [
      { text: "Ad", value: "displayName" },
      { text: "E-posta", value: "primaryEmail" },
      { text: "Telefon", value: "primaryPhone" },
      { text: "Telegram", value: "telegramChatId" },
      { text: "", value: "action", sortable: false, width: 60 },
    ],
    snack: false,
    snackText: "",
    snackColor: "success",
  }),
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.contacts = await ChatflowApi.getContacts({
          q: this.search.trim() || undefined,
        });
      } catch (e) {
        this.notify(e.response?.data?.message || "Rehber yüklenemedi", "error");
      }
      this.loading = false;
    },
    openNew() {
      this.editId = null;
      this.form = { displayName: "", email: "", phone: "", telegramChatId: "" };
      this.dialog = true;
    },
    openEdit(item) {
      this.editId = item.id;
      this.form = {
        displayName: item.displayName || "",
        email: item.primaryEmail || "",
        phone: item.primaryPhone || "",
        telegramChatId: item.telegramChatId || "",
      };
      this.dialog = true;
    },
    async save() {
      this.saving = true;
      try {
        if (this.editId) {
          await ChatflowApi.updateContact(this.editId, { ...this.form });
        } else {
          await ChatflowApi.createContact({ ...this.form });
        }
        this.dialog = false;
        await this.load();
        this.notify("Kaydedildi", "success");
      } catch (e) {
        this.notify(e.response?.data?.message || "Kayıt başarısız", "error");
      }
      this.saving = false;
    },
    notify(text, color = "success") {
      this.snackText = text;
      this.snackColor = color;
      this.snack = true;
    },
  },
};
</script>

<style scoped>
.cf-card {
  border-radius: 8px;
}

.cf-search {
  max-width: 260px;
}
</style>
